import { _ as _applyDecoratedDescriptor, a as _initializerDefineProperty } from '../_rollupPluginBabelHelpers-7db585ca.js';
import { inject } from '@ember/service';
import Helper from '@ember/component/helper';
import handleQueryParams from '../utils/handle-query-params.js';
import trackActiveRoute from '../utils/track-active-route.js';

var _class, _descriptor;
let IsActiveHelper = (_class = class IsActiveHelper extends Helper {
  constructor(...args) {
    super(...args);

    _initializerDefineProperty(this, "router", _descriptor, this);
  }

  compute(_params) {
    trackActiveRoute(this.router);
    let params = handleQueryParams(_params);
    return this.router.isActive(...params);
  }

}, (_descriptor = _applyDecoratedDescriptor(_class.prototype, "router", [inject], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
})), _class);

export { IsActiveHelper as default };
